import { render, staticRenderFns } from "./card-review-detail-v2.vue?vue&type=template&id=4c17fe64&scoped=true"
import script from "./card-review-detail-v2.vue?vue&type=script&lang=js"
export * from "./card-review-detail-v2.vue?vue&type=script&lang=js"
import style0 from "./card-review-detail-v2.vue?vue&type=style&index=0&id=4c17fe64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c17fe64",
  null
  
)

export default component.exports